import ls from "@/services/local-storage";
import { useAuthStore } from "@/stores/auth.store";
import { useRouter } from "vue-router";

export const useLogout = () => {
  const authStore = useAuthStore();
  const router = useRouter();

  const logout = (expired = false) => {
    ls.clearToken();
    authStore.clearLoggedIn();
    router.replace({
      name: "login",
      ...(expired && { query: { session_expired: "true" } })
    });
  };

  return { logout };
};
